import '@sweep-io/sweep-design/dist/colors/sweepColors.css';
import './App.css';
import { Outlet } from 'react-router';
import { useAuthenticateUser } from '../hooks/useAuthenticateUser';
import LoadingSweep from './common/LoadingSweep';
import { GeneralError } from './pages/GeneralError';
import VerificationNeeded from './pages/onboarding/VerificationNeeded';
import PersonalEmailBlock from './pages/onboarding/PersonalEmailBlock';
import { Notifications } from './notifications/Notifications';
import ErrorBoundary from '../ErrorBoundary';
import { AccountSelectionPage } from './account-selection/AccountSelectionPage';
import { useRemoveAuthOrgQueryParamFromUrl } from '../hooks/useRemoveAuthOrgQueryParamFromUrl';

const AuthenticatedApp = () => {
  useRemoveAuthOrgQueryParamFromUrl();
  //Here goes logic that is relevant to all routes (including "*Auth2Redirect")
  return <Outlet />;
};

export const App = () => {
  const { userInfo, error, isPersonalEmail, notVerifiedAuthUserDetails, isNoAccountSetError } =
    useAuthenticateUser();
  const { isVerificationNeeded, authUserId, authUserEmail } = notVerifiedAuthUserDetails;
  const renderError = !!error;

  return (
    <ErrorBoundary>
      <div data-testid="sweep-app" style={{ height: '100%' }}>
        <Notifications />
        {userInfo ? (
          <AuthenticatedApp />
        ) : isPersonalEmail ? (
          <PersonalEmailBlock />
        ) : isVerificationNeeded ? (
          <VerificationNeeded authUserId={authUserId} authUserEmail={authUserEmail} />
        ) : isNoAccountSetError ? (
          <AccountSelectionPage />
        ) : renderError ? (
          <GeneralError />
        ) : (
          <LoadingSweep />
        )}
      </div>
    </ErrorBoundary>
  );
};
